export default "__VITE_ASSET__DCnXVZne__"